"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index3 = _interopRequireDefault(require("@/components/SailScheduleOne/index.vue"));
var _newManifestEDI = require("@/api/bookSpace/newManifestEDI");
var _vuex = require("vuex");
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
var _booking = require("@/api/bookSpace/booking");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BillConsigneeApplication',
  components: {
    sailSchedule: _index3.default,
    Pagination: _index2.default,
    filterColumn: _index.default
  },
  data: function data() {
    var _this = this;
    var validateVesselCode = function validateVesselCode(rule, value, callback) {
      if (_this.searchForm.vesselCode == '') {
        callback(new Error(_this.$t('userCenter.newManifestEDI.inputVvl')));
      }
      if (_this.searchForm.voyageLeg == '') {
        callback(new Error(_this.$t('userCenter.newManifestEDI.inputVvl')));
      }
      if (_this.searchForm.voyageNo == '') {
        callback(new Error(_this.$t('userCenter.newManifestEDI.inputVvl')));
      }
      callback();
    };
    return {
      deleteReasonList: [],
      sailScheduleDialogType: '',
      sailScheduleDialogVisible: false,
      dataTotal: 0,
      searchFormRules: {
        vesselCode: [{
          required: true,
          validator: validateVesselCode,
          trigger: 'blur'
        }],
        pol: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.inputPol'),
          trigger: 'blur'
        }]
      },
      dialogFormRules: {
        customsId: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.inputCustomsId'),
          trigger: 'blur'
        }],
        districtCode: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.inputDistrictCode'),
          trigger: 'blur'
        }],
        loadPlace: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.inputLoadPlace'),
          trigger: 'blur'
        }],
        porFormat: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.inputPorFormat'),
          trigger: 'blur'
        }]
      },
      dialogRules: {
        vesselCode: [{
          required: true,
          validator: this.validateVesselFields,
          trigger: 'blur'
        }],
        reportType: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.reportTypeRequireValidate'),
          trigger: 'blur'
        }],
        deleteReason: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.deleteReasonRequireValidate'),
          trigger: 'blur'
        }],
        loadShipTime: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.loadShipTimeRequireValidate'),
          trigger: 'blur'
        }],
        changeReson: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.changeResonRequireValidate'),
          trigger: 'blur'
        }],
        changeContactName: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.changeContactNameRequire'),
          trigger: 'blur'
        }],
        changeContactTel: [{
          required: true,
          message: this.$t('userCenter.newManifestEDI.changeContactTelRequireValidate'),
          trigger: 'blur'
        }]
      },
      openDialog1: false,
      openDialog2: false,
      openDialog3: false,
      openDialog4: false,
      openDialog5: false,
      dialogType: '',
      tableCostData: [],
      hotSettings: {
        dragCheck: true,
        height: 'auto',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      portOptions: [{
        value: 'CNSHA',
        label: 'CNSHA'
      }],
      billForm: {
        companyName: '',
        companyNameCn: '',
        usci: '',
        portCode: '',
        vesselCode: '',
        voyageNo: '',
        voyageLeg: ''
      },
      billForm3: {
        companyName: '',
        companyNameCn: '',
        usci: '',
        portCode: '',
        vesselCode: '',
        voyageNo: '',
        voyageLeg: ''
      },
      searchForm: {
        vesselCode: '',
        voyageNo: '',
        voyageLeg: '',
        preLock: '',
        sendLoad: '',
        loadSuccess: '',
        blNo: '',
        sendPre: '',
        filterSpliteBill: '',
        cnt: '',
        clear: '',
        pol: '',
        scBef: 0,
        scAft: 0,
        userCode: 'COM_TEST5'
      },
      dialogForm: {
        porFormat: '',
        bookingHeadIds: '',
        customsId: '',
        districtCode: '',
        loadPlace: '',
        pol: '',
        reportType: '',
        deleteReason: '',
        loadShipTime: '',
        changeReson: '',
        changeContactName: '',
        changeContactTel: '',
        vesselCode: '',
        voyageNo: '',
        voyageLeg: ''
      },
      bookingForm: {
        openDialogItem: ''
      },
      userInfo: this.$store.state.user.userInfo,
      selectionIds: '',
      tableDataStutus: [],
      statusValueList: [{
        value: 0,
        label: '待提交'
      }, {
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '已审核'
      }, {
        value: 3,
        label: '取消审核'
      }],
      fileTypeList: [{
        value: '9',
        label: '主要申报(一次)',
        labelEn: 'First Report'
      }, {
        value: '0',
        label: '次要申报(二次)',
        labelEn: 'Second Report'
      }, {
        value: '5',
        label: '更改报文',
        labelEn: 'Modify'
      }, {
        value: '3',
        label: '删除报文',
        labelEn: 'Delete'
      }],
      fileTypeList5: [{
        value: '2',
        label: '增加',
        labelEn: 'AddReport'
      }, {
        value: '3',
        label: '删除报文',
        labelEn: 'Delete'
      }],
      ediFunctionCode: [{
        value: '9',
        label: '原始',
        labelEn: 'Original'
      }, {
        value: '5',
        label: '增加',
        labelEn: 'Correct'
      }, {
        value: '4',
        label: '删除',
        labelEn: 'Delete'
      }, {
        value: '3',
        label: '向船公司订舱',
        labelEn: 'Secondary Report'
      }],
      IsYesOrNotData: [{
        value: 0,
        label: '全部',
        labelEn: 'All'
      }, {
        value: 1,
        label: '是',
        labelEn: 'Yes'
      }, {
        value: 2,
        label: '否',
        labelEn: 'No'
      }],
      IsYesOrNotDataEmpty: [{
        value: '',
        label: '全部',
        labelEn: 'All'
      }, {
        value: 1,
        label: '是',
        labelEn: 'Yes'
      }, {
        value: 2,
        label: '否',
        labelEn: 'No'
      }],
      IsYesOrNotDataTableString: [{
        codeValue: '1',
        displayValueCn: '是',
        displayValue: 'Yes'
      }, {
        codeValue: '0',
        displayValueCn: '否',
        displayValue: 'No'
      }],
      IsYesOrNotDataTableDigit: [{
        codeValue: 1,
        displayValueCn: '是',
        displayValue: 'Yes'
      }, {
        codeValue: 0,
        displayValueCn: '否',
        displayValue: 'No'
      }],
      IsYesOrNotDataZero: [{
        value: 0,
        label: '全部',
        labelEn: 'All'
      }, {
        value: 1,
        label: '是',
        labelEn: 'Yes'
      }, {
        value: 2,
        label: '否',
        labelEn: 'No'
      }],
      ediFileTypeData: [],
      isCancelSubmit: false,
      isCancelDel: false,
      uploadDisable: false,
      fileListDG: [],
      fileListMSDS: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  watch: {
    tableDataStutus: {
      handler: function handler(val) {
        console.log('val', val);
        var i = 0;
        for (i = 0; i < val.length; i++) {
          if (val[i].status == 0) {
            this.isCancelSubmit = true;
            return;
          } else if (val[i].status == 1) {
            this.isCancelDel = true;
            return;
          } else if (val[i].status == 2) {
            this.isCancelSubmit = true;
            this.isCancelDel = true;
            return;
          } else if (val[i].status == 3) {
            this.isCancelSubmit = true;
            return;
          }
        }
        if (i == val.length) {
          this.isCancelSubmit = false;
          this.isCancelDel = false;
        }
      },
      deep: true
    },
    'searchForm.pol': {
      handler: function handler(newValue) {
        this.updateEdiTypeList(newValue);
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    console.log('this.userInfo', this.userInfo);
    this.$dictionary.get(['DELETE_REASON'], true).then(function (res) {
      if (res.DELETE_REASON) {
        _this2.deleteReasonList = res.DELETE_REASON;
      }
    });
    this.$nextTick(function () {
      _this2.resizeHotTable();
    });

    // 尝试从 localStorage 读取缓存
    var cachedPol = localStorage.getItem('newManifestEDI_pol');
    var cachedLoadPlace = localStorage.getItem('newManifestEDI_loadPlace');
    var cachedDistrictCode = localStorage.getItem('newManifestEDI_districtCode');
    var cachedCustomsId = localStorage.getItem('newManifestEDI_customsId');
    this.searchForm.clear = '';
    this.searchForm.sendPre = '';
    this.searchForm.sendLoad = '';
    this.searchForm.preLock = '';
    this.searchForm.filterSpliteBill = '';
    this.searchForm.cnt = '';
    this.searchForm.loadSuccess = '';

    // 如果缓存存在，则使用缓存值，否则使用默认值
    if (cachedPol) {
      this.searchForm.pol = cachedPol;
    } else {
      // 初始值设为空，将由 updateEdiTypeList 处理
      this.searchForm.pol = '';
    }
    if (cachedCustomsId) {
      this.dialogForm.customsId = cachedCustomsId;
    } else {
      this.dialogForm.customsId = '';
    }
    if (cachedDistrictCode) {
      this.dialogForm.districtCode = cachedDistrictCode;
    } else {
      this.dialogForm.districtCode = '';
    }
    if (cachedLoadPlace) {
      this.dialogForm.loadPlace = cachedLoadPlace;
    } else {
      this.dialogForm.loadPlace = '';
    }

    // porFormat 在 updateEdiTypeList 里设置，这里不需要初始值
    // 初始化默认为空
    this.dialogForm.porFormat = '';
  },
  methods: {
    validateNull: _validate.validateNull,
    loadDataByBLNo: function loadDataByBLNo(val) {
      var _this3 = this;
      if (val) {
        this.loading = (0, _utils.load)();
        (0, _newManifestEDI.loadBookingHeadByBLNo)(val).then(function (res) {
          if (res.success) {
            _this3.searchForm.pol = res.data.pol;
            _this3.searchForm.vesselCode = res.data.vesselCode;
            _this3.searchForm.voyageNo = res.data.voyageNo;
            _this3.searchForm.voyageLeg = res.data.voyageLeg;
          }
        }).finally(function () {
          _this3.loading.close();
        });
      }
    },
    blNoChange: function blNoChange() {
      this.searchForm.blNo = this.searchForm.blNo.trim();
    },
    handleOpenVesselSearch: function handleOpenVesselSearch() {
      this.sailScheduleDialogType = 'search';
      this.sailScheduleDialogVisible = true;
    },
    handleOpenVesselDialog2: function handleOpenVesselDialog2() {
      this.sailScheduleDialogType = 'dialog2';
      this.sailScheduleDialogVisible = true;
    },
    handleOpenVesselDialog3: function handleOpenVesselDialog3() {
      this.sailScheduleDialogType = 'dialog3';
      this.sailScheduleDialogVisible = true;
    },
    selectionChangeSailSchedule: function selectionChangeSailSchedule(row) {
      this.sailScheduleDialogVisible = false;
      if (this.sailScheduleDialogType == 'search') {
        this.searchForm.vesselCode = row.vesselCode;
        // this.searchForm.vesselName = row.vesselName
        this.searchForm.voyageLeg = row.voyageLeg;
        this.searchForm.voyageNo = row.voyageNo;
      } else if (this.sailScheduleDialogType == 'dialog2') {
        this.billForm.vesselCode = row.vesselCode;
        // this.billForm.vesselName = row.vesselName
        this.billForm.voyageLeg = row.voyageLeg;
        this.billForm.voyageNo = row.voyageNo;
      } else if (this.sailScheduleDialogType == 'dialog3') {
        // 没看懂billForm3是在哪用到了
        this.billForm3.vesselCode = row.vesselCode;
        // this.billForm3.vesselName = row.vesselName
        this.billForm3.voyageLeg = row.voyageLeg;
        this.billForm3.voyageNo = row.voyageNo;
        this.dialogForm.vesselCode = row.vesselCode;
        this.dialogForm.voyageLeg = row.voyageLeg;
        this.dialogForm.voyageNo = row.voyageNo;
      }
    },
    hotTableSelect: function hotTableSelect(data) {
      console.log('data', data);
      var array = '';
      this.$refs.hotTableCost.getSelections().forEach(function (e) {
        array += e.bkId + ',';
      });
      this.selectionIds = array;
      this.uploadDisable = !!this.selectionIds;
      console.log('this.selectionIds', this.selectionIds);
    },
    closeDialog: function closeDialog() {
      this.dialogForm.bookingHeadIds = '';
      this.dialogForm.reportType = '';
      this.dialogForm.deleteReason = '';
      this.dialogForm.loadShipTime = '';
      this.dialogForm.changeReson = '';
      this.dialogForm.changeContactName = '';
      this.dialogForm.changeContactTel = '';
      this.dialogForm.vesselCode = '';
      this.dialogForm.voyageNo = '';
      this.dialogForm.voyageLeg = '';
    },
    handleEdit: function handleEdit(row) {
      var data = this.$refs.hotTableCost.getSelected();
      // if( !data.status==0 || !data.status==3){
      //   this.$message({
      //     message:  this.$t('userCenter.billConsigneeApplication.isEditText'),
      //     type: 'warning'
      //   })
      //   return
      // }

      this.dialogType = 'edit';
      this.billForm = JSON.parse(JSON.stringify(data));
      this.openDialog1 = true;
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTableCost.resizeTo();
    },
    resetForm: function resetForm() {
      this.searchForm.vesselCode = '';
      this.searchForm.voyageNo = '';
      this.searchForm.voyageLeg = '';
      this.searchForm.blNo = '';
      this.searchForm.pol = '';
      this.searchForm.scBef = 0;
      this.searchForm.clear = '';
      this.searchForm.scAft = 0;
      this.searchForm.sendPre = '';
      this.searchForm.sendLoad = '';
      this.searchForm.preLock = '';
      this.searchForm.filterSpliteBill = '';
      this.searchForm.cnt = '';
      this.searchForm.loadSuccess = '';
      // this.searchForm.vesselName = ''
    },
    openDialogType: function () {
      var _openDialogType = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee8() {
        var _this4 = this;
        var isValid, rowSelectNew, rowSelect, arrId, porFormatHandlers, handler;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return this.$refs.dialogFormRulesFirstRef.validate();
            case 3:
              isValid = _context8.sent;
              if (isValid) {
                _context8.next = 6;
                break;
              }
              return _context8.abrupt("return", false);
            case 6:
              // 写入 localStorage 缓存
              localStorage.setItem('newManifestEDI_pol', this.searchForm.pol);
              localStorage.setItem('newManifestEDI_loadPlace', this.dialogForm.loadPlace);
              localStorage.setItem('newManifestEDI_districtCode', this.dialogForm.districtCode);
              localStorage.setItem('newManifestEDI_customsId', this.dialogForm.customsId);

              // 2. 检查文件类型是否选择
              if (this.dialogForm.porFormat) {
                _context8.next = 13;
                break;
              }
              this.$message.warning(this.$t('userCenter.newManifestEDI.isSelectFileType'));
              return _context8.abrupt("return");
            case 13:
              if (this.selectionIds) {
                _context8.next = 16;
                break;
              }
              this.$message.warning(this.$t('userCenter.billConsigneeApplication.isSelectData'));
              return _context8.abrupt("return");
            case 16:
              // 4. 获取选中行数据
              rowSelectNew = this.$refs.hotTableCost.getSelections();
              rowSelect = rowSelectNew[0];
              arrId = rowSelectNew.map(function (item) {
                return item.bkId;
              }); // 5. 设置通用的dialogForm数据
              Object.assign(this.dialogForm, {
                vesselCode: rowSelect.vesselCode,
                voyageNo: rowSelect.voyageNo,
                voyageLeg: rowSelect.voyageLeg,
                pol: rowSelect.pol,
                bookingHeadIds: arrId.join(',')
              });

              // 6. 根据不同的porFormat处理
              porFormatHandlers = {
                'OBM2SITC_VIP_DROP_GOOD_OUT': function OBM2SITC_VIP_DROP_GOOD_OUT() {
                  _this4.openDialog1 = true;
                },
                'OBM2SITC_VIP_CHANGE_TOOL_OUT': function OBM2SITC_VIP_CHANGE_TOOL_OUT() {
                  _this4.openDialog2 = true;
                },
                'OBM2SITC_VIP_CHANGE_TRANS_OUT': function OBM2SITC_VIP_CHANGE_TRANS_OUT() {
                  // 清空船名航次信息
                  _this4.dialogForm.vesselCode = '';
                  _this4.dialogForm.voyageNo = '';
                  _this4.dialogForm.voyageLeg = '';
                  _this4.openDialog3 = true;
                },
                'OBM2SITC_VIP_YP_144_OUT': function () {
                  var _OBM2SITC_VIP_YP_144_OUT = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this4.handleLoadShipTime(rowSelect);
                        case 2:
                          _this4.openDialog4 = true;
                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  function OBM2SITC_VIP_YP_144_OUT() {
                    return _OBM2SITC_VIP_YP_144_OUT.apply(this, arguments);
                  }
                  return OBM2SITC_VIP_YP_144_OUT;
                }(),
                'OBM2SITC_VIP_YP144_NGB_OUT': function () {
                  var _OBM2SITC_VIP_YP144_NGB_OUT = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this4.handleLoadShipTime(rowSelect);
                        case 2:
                          _this4.openDialog4 = true;
                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2);
                  }));
                  function OBM2SITC_VIP_YP144_NGB_OUT() {
                    return _OBM2SITC_VIP_YP144_NGB_OUT.apply(this, arguments);
                  }
                  return OBM2SITC_VIP_YP144_NGB_OUT;
                }(),
                'BKM2SITC_VIP_ZZ144_TAO_OUT': function () {
                  var _BKM2SITC_VIP_ZZ144_TAO_OUT = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _this4.handleLoadShipTime(rowSelect);
                        case 2:
                          _this4.openDialog5 = true;
                        case 3:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  function BKM2SITC_VIP_ZZ144_TAO_OUT() {
                    return _BKM2SITC_VIP_ZZ144_TAO_OUT.apply(this, arguments);
                  }
                  return BKM2SITC_VIP_ZZ144_TAO_OUT;
                }(),
                'OBM2SITC_CNNGB_CTNVGM_OUT': function () {
                  var _OBM2SITC_CNNGB_CTNVGM_OUT = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return _this4.sendEdiWithoutCheck(rowSelect.pol);
                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  function OBM2SITC_CNNGB_CTNVGM_OUT() {
                    return _OBM2SITC_CNNGB_CTNVGM_OUT.apply(this, arguments);
                  }
                  return OBM2SITC_CNNGB_CTNVGM_OUT;
                }(),
                'OBM2SITC_CNNGB_VGM_YZ_OUT': function () {
                  var _OBM2SITC_CNNGB_VGM_YZ_OUT = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return _this4.sendEdiWithoutCheck(rowSelect.pol);
                        case 2:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5);
                  }));
                  function OBM2SITC_CNNGB_VGM_YZ_OUT() {
                    return _OBM2SITC_CNNGB_VGM_YZ_OUT.apply(this, arguments);
                  }
                  return OBM2SITC_CNNGB_VGM_YZ_OUT;
                }(),
                'OBM2SITC_CNWNZ_YPMFT_144_OUT': function () {
                  var _OBM2SITC_CNWNZ_YPMFT_144_OUT = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
                      while (1) switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return _this4.handleLoadShipTime(rowSelect);
                        case 2:
                          _this4.openDialog4 = true;
                        case 3:
                        case "end":
                          return _context6.stop();
                      }
                    }, _callee6);
                  }));
                  function OBM2SITC_CNWNZ_YPMFT_144_OUT() {
                    return _OBM2SITC_CNWNZ_YPMFT_144_OUT.apply(this, arguments);
                  }
                  return OBM2SITC_CNWNZ_YPMFT_144_OUT;
                }(),
                'OBM2SITC_NGB_YZ_YP_OUT': function () {
                  var _OBM2SITC_NGB_YZ_YP_OUT = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
                      while (1) switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return _this4.handleLoadShipTime(rowSelect);
                        case 2:
                          _this4.openDialog4 = true;
                        case 3:
                        case "end":
                          return _context7.stop();
                      }
                    }, _callee7);
                  }));
                  function OBM2SITC_NGB_YZ_YP_OUT() {
                    return _OBM2SITC_NGB_YZ_YP_OUT.apply(this, arguments);
                  }
                  return OBM2SITC_NGB_YZ_YP_OUT;
                }()
              }; // 7. 执行对应的处理函数
              handler = porFormatHandlers[this.dialogForm.porFormat];
              if (!handler) {
                _context8.next = 25;
                break;
              }
              _context8.next = 25;
              return handler();
            case 25:
              _context8.next = 31;
              break;
            case 27:
              _context8.prev = 27;
              _context8.t0 = _context8["catch"](0);
              console.error('openDialogType error:', _context8.t0);
              this.$message.error(this.$t('common.operationFailed'));
            case 31:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 27]]);
      }));
      function openDialogType() {
        return _openDialogType.apply(this, arguments);
      }
      return openDialogType;
    }(),
    // 抽取获取装船时间的公共方法
    handleLoadShipTime: function () {
      var _handleLoadShipTime = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee9(rowSelect) {
        var params, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              params = {
                vesselCode: rowSelect.vesselCode,
                voyageNo: rowSelect.voyageNo,
                voyageLeg: rowSelect.voyageLeg,
                pol: rowSelect.pol
              };
              _context9.next = 3;
              return (0, _newManifestEDI.getLoadShipTime)(params);
            case 3:
              res = _context9.sent;
              if (res.success) {
                this.dialogForm.loadShipTime = res.data;
              }
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function handleLoadShipTime(_x) {
        return _handleLoadShipTime.apply(this, arguments);
      }
      return handleLoadShipTime;
    }(),
    searchFormData: function searchFormData() {
      var _this5 = this;
      this.$refs.searchFormRef.validate(function (valid) {
        if (valid) {
          if (_this5.searchForm.scBef == true) {
            _this5.searchForm.scBef = 1;
          } else {
            _this5.searchForm.scBef = 0;
          }
          if (_this5.searchForm.scAft == true) {
            _this5.searchForm.scAft = 1;
          } else {
            _this5.searchForm.scAft = 0;
          }
          console.log('this.searchForm', _this5.searchForm);
          var data = JSON.parse(JSON.stringify(_this5.searchForm));
          data.currentPage = _this5.listQuery.currentPage;
          data.pageSize = _this5.listQuery.pageSize;
          _this5.loading = (0, _utils.load)();
          (0, _newManifestEDI.getQueryListManifest)(data).then(function (res) {
            // console.log('res', res)

            if (res.data.records.length > 0) {
              res.data.records.map(function (item, index) {
                if (item.preLock == null || item.preLock == '') {
                  item.preLock = '0';
                }
              });
            }
            _this5.tableCostData = res.data.records;
            _this5.tableCostData.forEach(function (item) {
              item.dgDeclareFormatter = item.dgDeclare == 0 ? '' : '√';
              item.chineseMSDSFormatter = item.chineseMSDS == 1 ? '√' : '';
            });
            _this5.selectionIds = [];
            _this5.listQuery.total = res.data.totalRecord;
            _this5.searchForm.scBef = 0;
            _this5.searchForm.scAft = 0;
            // console.log(' this.tableCostData', this.tableCostData)
          }).catch(function (err) {
            console.log('err', err);
          }).finally(function () {
            _this5.loading.close();
          });
        } else {
          return false;
        }
      });
    },
    sendEdiWithoutCheck: function sendEdiWithoutCheck(pol) {
      var _this6 = this;
      var data = JSON.parse(JSON.stringify(this.dialogForm));
      data.pol = pol;
      this.loading = (0, _utils.load)();
      (0, _newManifestEDI.getDoExportEdi)(data).then(function (res) {
        if (res.success) {
          _this6.$message({
            message: _this6.$t('userCenter.newManifestEDI.ediSuccess'),
            type: 'success'
          });
          _this6.searchFormData();
        } else {
          _this6.$message({
            message: res.errorMessages[0],
            type: 'error'
          });
        }
      }).catch(function (err) {}).finally(function () {
        _this6.loading.close();
      });
    },
    saveFormClick: function saveFormClick() {
      var _this7 = this;
      // 根据报文格式判断需要校验的必填项表单
      var fromRef;
      if (this.dialogForm.porFormat === 'OBM2SITC_VIP_DROP_GOOD_OUT') {
        fromRef = this.$refs.dialogForm1;
      } else if (this.dialogForm.porFormat === 'OBM2SITC_VIP_CHANGE_TOOL_OUT') {
        fromRef = this.$refs.dialogForm2;
      } else if (this.dialogForm.porFormat === 'OBM2SITC_VIP_CHANGE_TRANS_OUT') {
        fromRef = this.$refs.dialogForm3;
      } else if (this.dialogForm.porFormat === 'OBM2SITC_VIP_YP_144_OUT') {
        fromRef = this.$refs.dialogForm4;
      } else if (this.dialogForm.porFormat === 'BKM2SITC_VIP_ZZ144_TAO_OUT') {
        fromRef = this.$refs.dialogForm5;
      } else if (this.dialogForm.porFormat === 'OBM2SITC_CNWNZ_YPMFT_144_OUT') {
        fromRef = this.$refs.dialogForm4;
      } else if (this.dialogForm.porFormat === 'OBM2SITC_VIP_YP144_NGB_OUT') {
        fromRef = this.$refs.dialogForm4;
      } else if (this.dialogForm.porFormat === 'OBM2SITC_NGB_YZ_YP_OUT') {
        fromRef = this.$refs.dialogForm4;
      }
      // EDI发送弹窗必填校验
      fromRef.validate(function (valid) {
        if (valid) {
          var params = {
            bookingHeadWebIds: _this7.selectionIds,
            porFormat: _this7.dialogForm.porFormat
          };
          _this7.loading = (0, _utils.load)();
          (0, _newManifestEDI.validateBookingHeadForEdi)(params).then(function (res) {
            if (res.data.length > 0) {
              _this7.$message({
                message: res.data,
                type: 'error'
              });
            } else {
              var data = JSON.parse(JSON.stringify(_this7.dialogForm));
              _this7.loading = (0, _utils.load)();
              (0, _newManifestEDI.getDoExportEdi)(data).then(function (res) {
                if (res.success) {
                  _this7.$message({
                    message: _this7.$t('userCenter.newManifestEDI.ediSuccess'),
                    type: 'success'
                  });
                  _this7.searchFormData();
                } else {
                  _this7.$message({
                    message: res.errorMessages[0],
                    type: 'error'
                  });
                }
              }).catch(function (err) {
                console.error('getDoExportEdi error:', err); // 处理错误
              }).finally(function () {
                _this7.loading.close();
                _this7.openDialog1 = false;
                _this7.openDialog2 = false;
                _this7.openDialog3 = false;
                _this7.openDialog4 = false;
                _this7.openDialog5 = false;
              });
            }
          }).catch(function (err) {}).finally(function () {
            _this7.loading.close();
          });
        } else {
          return false;
        }
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    addClick: function addClick() {
      this.dialogType = 'add';
      this.openDialog1 = true;
      this.billForm.portCode = 'CNSHA';
    },
    /**
     * 校验弹窗船名航次
     */
    validateVesselFields: function validateVesselFields(rule, value, callback) {
      if (this.dialogForm.vesselCode === '' && this.dialogForm.voyageNo === '' && this.dialogForm.voyageLeg === '') {
        callback(new Error(this.$t('userCenter.ediFeedBack.vesselAndVoyageNotNull')));
      } else {
        callback();
      }
    },
    getEdiFeedBack: function getEdiFeedBack() {
      var hotTableSelections = this.$refs.hotTableCost.getSelections();
      if (hotTableSelections.length === 0 || hotTableSelections.length > 1) {
        this.$message.error(this.$t('userCenter.ediFeedBack.checkOneRecord'));
        return;
      }
      if ((0, _validate.validateNull)(hotTableSelections[0].blNo) || (0, _validate.validateNull)(hotTableSelections[0].vvl) || (0, _validate.validateNull)(hotTableSelections[0].pol)) {
        this.$message({
          message: this.$t('userCenter.ediFeedBack.missingData'),
          type: 'warning'
        });
        return;
      }
      this.$router.push({
        path: '/bookingSpace/ediFeedBack',
        query: {
          blNo: hotTableSelections[0].blNo,
          portCode: hotTableSelections[0].pol,
          vesselCode: hotTableSelections[0].vesselCode,
          voyageNo: hotTableSelections[0].voyageNo,
          voyageLeg: hotTableSelections[0].voyageLeg
        }
      });
    },
    isTableDataSelected: function isTableDataSelected() {
      var hotTableSelections = this.$refs.hotTableCost.getSelections();
      return hotTableSelections.length > 0;
    },
    uploadDgDeclare: function uploadDgDeclare(item) {
      var _this8 = this;
      if (!this.isTableDataSelected()) {
        this.$message.error('请选择一条数据');
        return;
      }
      if (!this.validateFile(item.file, this.fileListDG)) {
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append('file', item.file);
      formDatas.append('bucket', 'commerce');
      var hotTableSelections = this.$refs.hotTableCost.getSelections();
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          var uploadData = {};
          uploadData.blNos = hotTableSelections.map(function (item) {
            return item.blNo;
          }).join(',');
          uploadData.fileId = res.fileId;
          uploadData.fileName = res.fileName;
          (0, _newManifestEDI.uploadDgDeclare)(uploadData).then(function (result) {
            if (result.success) {
              _this8.$message({
                message: _this8.$t('userCenter.newManifestEDI.uploadSuccess'),
                type: 'success'
              });
            }
            _this8.searchFormData();
          });
        } else {
          _this8.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this8.loading.close();
      });
    },
    uploadChineseMSDS: function uploadChineseMSDS(item) {
      var _this9 = this;
      if (!this.validateFile(item.file, this.fileListMSDS)) {
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append('file', item.file);
      formDatas.append('bucket', 'commerce');
      var hotTableSelections = this.$refs.hotTableCost.getSelections();
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          var uploadData = {};
          uploadData.blNos = hotTableSelections.map(function (item) {
            return item.blNo;
          }).join(',');
          uploadData.fileId = res.fileId;
          uploadData.fileName = res.fileName;
          (0, _newManifestEDI.uploadChineseMSDS)(uploadData).then(function (result) {
            if (result.success) {
              _this9.$message({
                message: _this9.$t('userCenter.newManifestEDI.uploadChineseMSDS'),
                type: 'success'
              });
            }
            _this9.searchFormData();
          });
        } else {
          _this9.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this9.loading.close();
      });
    },
    // 通用文件校验方法
    validateFile: function validateFile(file, fileList) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!this.isTableDataSelected()) {
        this.$message.error('请选择一条数据');
        return false;
      }
      var _options$maxSize = options.maxSize,
        maxSize = _options$maxSize === void 0 ? 10 * 1024 * 1024 : _options$maxSize;
      if (!file) {
        return false;
      }

      // 检查文件大小
      if (file.size > maxSize) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        fileList = [];
        return false;
      }
      return true;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isLt10M;
    },
    onChange: function onChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.fileList = fileList;
    },
    updateEdiTypeList: function () {
      var _updateEdiTypeList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee10(pol) {
        var _this10 = this;
        var resetData, res, ediTypeList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              // 数据重置函数，集中管理字段重置逻辑
              resetData = function resetData() {
                _this10.ediFileTypeData = [];
                _this10.dialogForm.porFormat = '';
                _this10.dialogForm.customsId = '';
                _this10.dialogForm.districtCode = '';
                _this10.dialogForm.loadPlace = '';
              }; // POL为空时，重置数据并直接返回
              if (pol) {
                _context10.next = 4;
                break;
              }
              resetData();
              return _context10.abrupt("return");
            case 4:
              this.loading = (0, _utils.load)();
              _context10.prev = 5;
              _context10.next = 8;
              return (0, _newManifestEDI.getEdiTypeInfoByPol)({
                pol: pol
              });
            case 8:
              res = _context10.sent;
              if (!(!res.success || !res.data)) {
                _context10.next = 12;
                break;
              }
              resetData();
              return _context10.abrupt("return");
            case 12:
              // 处理EDI类型列表
              ediTypeList = res.data.ediTypeList || [];
              if (ediTypeList.length > 0) {
                this.ediFileTypeData = ediTypeList.map(function (item) {
                  return {
                    value: item.interChangeCode,
                    label: item.ediTypeName,
                    labelEn: item.ediTypeName
                  };
                });

                // 设置默认的选中值为第一个选项
                this.dialogForm.porFormat = this.ediFileTypeData[0].value;
              } else {
                this.ediFileTypeData = [];
                this.dialogForm.porFormat = '';
              }

              // 设置其他字段，处理可能为空的情况
              this.dialogForm.customsId = res.data.customsId || '';
              this.dialogForm.districtCode = res.data.districtCode || '';
              this.dialogForm.loadPlace = res.data.loadPlace || '';
              _context10.next = 23;
              break;
            case 19:
              _context10.prev = 19;
              _context10.t0 = _context10["catch"](5);
              resetData();
              this.$message.error(this.$t('common.operationFailed'));
            case 23:
              _context10.prev = 23;
              this.loading.close();
              return _context10.finish(23);
            case 26:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[5, 19, 23, 26]]);
      }));
      function updateEdiTypeList(_x2) {
        return _updateEdiTypeList.apply(this, arguments);
      }
      return updateEdiTypeList;
    }()
  }
};